import styled from '@emotion/styled';

export const Body = styled.div`
  display: grid;
  row-gap: 12px;
  padding: 16px;
  cursor: pointer;
  user-select: none;
`;
